import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { hideUnregisterBox } from "./coeSlice";
import { env } from "../../environment";
import { XIcon } from "@heroicons/react/solid";
export default function COEUnregisterBox() {
  const unregisterBox = useSelector((state) => state.coe.unregisterBox);

  const selectedInmate = useSelector((state) => state.coe.selectedInmate);
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");

  const [success, setSuccess] = useState(false);

  const dispatch = useDispatch();

  if (unregisterBox == true) {
    document.body.style.overflow = "hidden";
  }

  function register() {
    console.log(email);
    if (email == confirmEmail && email != "" && validateEmail(email)) {
      let fetchURL =
        env +
        "inmateSubscribe.do?method=unsubscribe&email=" +
        email +
        "&email2=" +
        confirmEmail +
        "&inmateId=" +
        selectedInmate.scdcId;
      fetch(fetchURL)
        .then((response) => response.json())
        .then((data) => {
          if (data.type == "success") {
            hideError();
            setSuccess(true);
            dispatch(hideUnregisterBox());
          }
        });
    } else if (validateEmail(email) == false && email != "") {
      document.getElementById("unsubError").innerHTML =
        "Email must be in a valid format.";
    } else if (email == "") {
      document.getElementById("unsubError").innerHTML =
        "Email is required. (255 characters max)";
    } else if (confirmEmail == "") {
      document.getElementById("unsubError").innerHTML =
        "Email Re-entry is required. (255 characters max)";
    } else if (email != confirmEmail) {
      document.getElementById("unsubError").innerHTML =
        "Email Addresses must match";
    }
  }

  function hideError() {
    document.getElementById("unsubError").innerHTML = "";
  }
  function validateEmail(email) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    }
    return false;
  }

  function exit() {
    dispatch(hideUnregisterBox());
    setSuccess(false);
    setEmail("");
    setConfirmEmail("");
    hideError();
    document.body.style.overflow = "auto";
  }
  return (
    <div>
      <div
        onClick={() => exit()}
        className=" z-40 w-full h-full bg-gray-100 opacity-80  fixed"
        style={{
          display: unregisterBox || success ? "" : "none",
        }}
      ></div>
      <div
        className=" z-50  m-auto bg-gray-300 fixed opacity-100 top-2/4 left-2/4 p-3 pb-1 sm:border-solid sm:border-black sm:border-4"
        style={{
          transform: "translate(-50%, -50%)",
          width: window.innerWidth < 640 ? "100%" : "500px",
          display: unregisterBox || success ? "" : "none",
        }}
      >
        <div
          style={{ display: unregisterBox ? "" : "none" }}
          className="shadow-lg"
        >
          <div className="p-2 bg-orange-light border border-black border-4 text-lg">
            Remove a Custodian Of Evidence (COE) Registration pursuant to S.C.
            Code §17-28-330(A)
          </div>
          <div className="bg-gray-100 p-2">
            <div className="text-red-500" id="unsubError"></div>
            <div className="pb-5">
              <div className="pb-1 ">Inmate Id: {selectedInmate.scdcId}</div>
              <div>
                Inmate Name: {selectedInmate.lname}, {selectedInmate.fname}{" "}
                {selectedInmate.mname}
              </div>
            </div>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                Email Address
              </label>
              <div className="mt-1">
                <input
                  type="text"
                  name="email"
                  id="email"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  placeholder="you@example.com"
                />
              </div>
            </div>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                Confirm Email Address
              </label>
              <div className="mt-1">
                <input
                  type="text"
                  name="email"
                  id="email"
                  value={confirmEmail}
                  onChange={(e) => setConfirmEmail(e.target.value)}
                  className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  placeholder="you@example.com"
                />
              </div>
            </div>
            <div>
              <button
                onClick={() => register()}
                className="p-2 mt-2 bg-blue-dark text-white rounded-md"
              >
                Register
              </button>
              <button
                className="p-2 mt-2 ml-2 bg-red-500 text-white rounded-md"
                onClick={() => {
                  exit();
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
        <div style={{ display: success ? "" : "none" }}>
          Your Request for a Removal of a Custodian Of Evidence (COE)
          Registration pursuant to S.C. Code §17-28-330(A) has been received and
          should be processed shortly. Please check your supplied email address
          for a confirmation link. Copyright © 2021 SCDCclose
        </div>
        <div className="float-right mt-2">
          <button onClick={exit}>
            <XIcon className="w-8" />
          </button>
        </div>
        Copyright © 2021 SCDC
      </div>
    </div>
  );
}
